import type { Icons } from '@ksyos/design-system';
import type { CSSProperties } from 'react';
import { Button } from '@ksyos/design-system';
import { Link as ReactRouterLink } from '@ksyos/router';
import type { IDropdownMenuItem } from './ButtonHeader';
import { ButtonHeader } from './ButtonHeader';

interface IAddButtonHeaderProps {
    buttonText: string;
    dropdownMenuItems?: IDropdownMenuItem[];
    hideButton?: boolean;
    icon?: Icons;
    link: string | { pathname: string; search?: string; state: { previousLocation: string } };
    outlined?: boolean;
    style?: CSSProperties;
    title: JSX.Element;
}

export function AddButtonHeader(props: IAddButtonHeaderProps) {
    return (
        <ButtonHeader
            dropdownMenuItems={props.dropdownMenuItems}
            style={props.style}
            title={props.title}
        >
            <>
                {!props.hideButton && (
                    <Button
                        as={ReactRouterLink}
                        iconLeft={props.icon ? props.icon : 'add'}
                        to={props.link}
                        variant={props.outlined ? 'outline' : 'solid'}
                    >
                        {props.buttonText}
                    </Button>
                )}
            </>
        </ButtonHeader>
    );
}
